'use client';

import { useSearchParams } from 'next/navigation';

import { core } from '@/features/v2/auth/register/page/localization/core';
import { useMountEffect } from '@/hooks/useMountEffect';
import { userUIStore } from '@/stores/userUIStore';

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  account_not_linked: core.authErrors.account_not_linked,
  unable_to_link_account: core.authErrors.unable_to_link_account,
};

export const useAuthErrorFromUrl = (): void => {
  const searchParams = useSearchParams();

  useMountEffect(() => {
    const errorCode = searchParams.get('error');
    if (!errorCode) return;

    const message = AUTH_ERROR_MESSAGES[errorCode] ?? core.authErrors.general;

    userUIStore.getState().setAlert({
      message,
      type: 'error',
      show: true,
      duration: 5000,
    });

    const url = new URL(window.location.href);
    url.searchParams.delete('error');
    url.searchParams.delete('error_description');
    window.history.replaceState({}, '', url.pathname + url.search);
  });
};
